import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import styles from "./icon-row.module.css"

@tagName("")
export default class IconRow extends Component {
  styles = styles
}
